(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clp-featured-tabs"] && !Shopify.designMode) return;
  try {
    
  class ClpFeaturedTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.clp-featured__tab'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
      });
    }
    selectTab(tab) {
      this.tabs.forEach((t) => {
        const panel = this.querySelector('#' + t.dataset.tabTarget);
        const isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', String(isActive));
        if (panel) panel.hidden = !isActive;
      });
    }
  }
  if (!customElements.get('clp-featured-tabs')) {
    customElements.define('clp-featured-tabs', ClpFeaturedTabs);
  }

  // Same drift/sliver bug already diagnosed and fixed for
  // .clp-hero-xsell__products in sections/clp-hero-xsell.liquid: Dawn's own
  // SliderComponent (assets/global.js) caches a single sliderItemOffset -
  // measured once via offsetLeft (always a rounded integer) - and reapplies
  // it via relative scrollLeft +/- step * offset arithmetic on every click.
  // This section's cards are a fluid calc() width
  // (clp-featured-tabs .clp-carousel--feature .clp-carousel__item { width:
  // calc((100% - 5 * 4px) / 6) }), so the fraction rounds differently at
  // different zoom levels/viewport widths, and that per-click error
  // compounds into a visible sliver at the carousel edge. Fix is identical
  // to Hero X-Sell's: never cache a step, re-measure the real card
  // positions fresh on every click and scroll straight to the target
  // card's own offsetLeft. Scoped to "clp-featured-tabs slider-component"
  // only, so Hero X-Sell, FloatZig X-Sell, Products+Image and every other
  // carousel reusing the same shared snippet/SliderComponent are untouched.
  window.clpBindFeaturedTabsArrows = window.clpBindFeaturedTabsArrows || function () {
    document.querySelectorAll('clp-featured-tabs slider-component').forEach(function (carousel) {
      if (carousel.dataset.clpArrowsBound) return;

      var list = carousel.querySelector('.clp-carousel__list');
      var prevButton = carousel.querySelector('button[name="previous"]');
      var nextButton = carousel.querySelector('button[name="next"]');
      if (!list || !prevButton || !nextButton) return;

      carousel.dataset.clpArrowsBound = 'true';

      function items() {
        return Array.from(list.querySelectorAll('.clp-carousel__item'));
      }

      // Finds the card closest to the current scroll position fresh, from
      // the live DOM, at click time - not a cached index - so this works
      // correctly even for a panel that was hidden (and unmeasurable) when
      // arrows were first bound at page load; by the time a user can click
      // its arrows, its tab is active and its cards have real geometry.
      function closestIndex() {
        var els = items();
        var closest = 0;
        var closestDistance = Infinity;
        els.forEach(function (el, i) {
          var distance = Math.abs(el.offsetLeft - list.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = i;
          }
        });
        return closest;
      }

      function scrollByOneCard(direction) {
        var els = items();
        if (els.length < 2) return;
        var targetIndex = Math.max(0, Math.min(els.length - 1, closestIndex() + direction));
        list.scrollTo({ left: els[targetIndex].offsetLeft, behavior: 'smooth' });
      }

      [prevButton, nextButton].forEach(function (button) {
        button.addEventListener(
          'click',
          function (event) {
            // Capture phase, ahead of SliderComponent's own bubble-phase
            // listener on this same button - stopImmediatePropagation (not
            // just stopPropagation) suppresses that sibling listener
            // outright so its stale-cached-offset scrollTo can't redirect
            // this handler's in-flight smooth scroll to a slightly-off
            // position. SliderComponent's disabled-state/page-counter
            // updates are unaffected - those come from its separate
            // 'scroll' listener on the list, which still fires normally
            // from this handler's own scrollTo call below.
            event.stopImmediatePropagation();
            scrollByOneCard(button.name === 'next' ? 1 : -1);
          },
          { capture: true }
        );
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.clpBindFeaturedTabsArrows);
  } else {
    window.clpBindFeaturedTabsArrows();
  }
  document.addEventListener('shopify:section:load', window.clpBindFeaturedTabsArrows);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp-floatzig-xsell"] && !Shopify.designMode) return;
  try {
    
  // FloatZig desktop carousel:
  // - 1 product per arrow click
  // - every position aligns to a real product-card boundary

  window.clpBindFloatzigCarouselArrows =
    window.clpBindFloatzigCarouselArrows || function () {
      document
        .querySelectorAll(
          '.clp-carousel--floatzig-feature.clp-carousel--desktop-slider'
        )
        .forEach(function (carousel) {
          if (carousel.dataset.clpArrowsBound) return;

          var list = carousel.querySelector('.clp-carousel__list');
          var oldPrevButton = carousel.querySelector(
            'button[name="previous"]'
          );
          var oldNextButton = carousel.querySelector(
            'button[name="next"]'
          );

          if (!list || !oldPrevButton || !oldNextButton) return;

          carousel.dataset.clpArrowsBound = 'true';

          // Remove Dawn SliderComponent's existing click handlers.
          // cloneNode() does not copy JS event listeners.
          var prevButton = oldPrevButton.cloneNode(true);
          var nextButton = oldNextButton.cloneNode(true);

          oldPrevButton.replaceWith(prevButton);
          oldNextButton.replaceWith(nextButton);

          function getItems() {
            return Array.from(
              list.querySelectorAll('.clp-carousel__item')
            );
          }

          /*
           * Get the actual rendered scroll position of a product card.
           *
           * This is intentionally NOT:
           *
           *   index * cardStep
           *
           * because percentage-based card widths and responsive gaps
           * can produce fractional positions.
           */
          function getItemScrollLeft(item) {
            if (!item) return list.scrollLeft;

            var listRect = list.getBoundingClientRect();
            var itemRect = item.getBoundingClientRect();

            return list.scrollLeft + (
              itemRect.left - listRect.left
            );
          }

          /*
           * Find the product card whose actual rendered position is
           * currently closest to the carousel's left edge.
           */
          function getCurrentIndex() {
            var items = getItems();

            if (!items.length) return 0;

            var listRect = list.getBoundingClientRect();
            var currentScrollLeft = list.scrollLeft;

            var closestIndex = 0;
            var closestDistance = Infinity;

            items.forEach(function (item, index) {
              var itemRect = item.getBoundingClientRect();

              var itemScrollLeft =
                currentScrollLeft +
                (itemRect.left - listRect.left);

              var distance = Math.abs(
                itemScrollLeft - currentScrollLeft
              );

              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            return closestIndex;
          }

          /*
           * Find the maximum valid index that can be positioned
           * without creating a partial card at the left edge.
           */
          function getMaxIndex() {
            var items = getItems();

            if (!items.length) return 0;

            var maxScroll =
              list.scrollWidth - list.clientWidth;

            var maxIndex = 0;

            items.forEach(function (item, index) {
              var itemRect = item.getBoundingClientRect();
              var listRect = list.getBoundingClientRect();

              var itemScrollLeft =
                list.scrollLeft +
                (itemRect.left - listRect.left);

              if (itemScrollLeft <= maxScroll + 1) {
                maxIndex = index;
              }
            });

            return maxIndex;
          }

          /*
           * Move to the ACTUAL DOM position of the requested card.
           *
           * This prevents the fractional-card problem caused by:
           *
           *   targetIndex * step
           */
          function scrollToIndex(index) {
            var items = getItems();

            if (!items.length) return;

            index = Math.max(
              0,
              Math.min(index, items.length - 1)
            );

            var targetItem = items[index];

            var target = getItemScrollLeft(targetItem);

            var maxScroll =
              list.scrollWidth - list.clientWidth;

            target = Math.max(
              0,
              Math.min(target, maxScroll)
            );

            list.scrollTo({
              left: target,
              behavior: 'smooth'
            });
          }

          function scrollByOneCard(direction) {
            var items = getItems();

            if (!items.length) return;

            var currentIndex = getCurrentIndex();
            var lastIndex = getMaxIndex();

            var targetIndex = currentIndex + direction;

            targetIndex = Math.max(
              0,
              Math.min(targetIndex, lastIndex)
            );

            if (targetIndex === currentIndex) {
              return;
            }

            scrollToIndex(targetIndex);
          }

          function refreshDisabled() {
            var items = getItems();

            if (!items.length) return;

            var currentIndex = getCurrentIndex();
            var lastIndex = getMaxIndex();

            prevButton.disabled = currentIndex <= 0;
            nextButton.disabled = currentIndex >= lastIndex;
          }

          function getMaxScrollLeft() {
            var items = getItems();
            if (!items.length) return 0;
            return getItemScrollLeft(items[getMaxIndex()]);
          }

          function isDesktopViewport() {
            return window.matchMedia('(min-width: 990px)').matches;
          }

          list.addEventListener(
            'wheel',
            function (event) {
              if (!event.deltaX || !isDesktopViewport()) return;

              var maxScrollLeft = getMaxScrollLeft();

              if (event.deltaX < 0 && list.scrollLeft <= 0.5) {
                event.preventDefault();
                return;
              }

              if (event.deltaX > 0 && list.scrollLeft >= maxScrollLeft - 0.5) {
                event.preventDefault();
              }
            },
            { passive: false }
          );

          list.addEventListener('scroll', function () {
            if (!isDesktopViewport()) return;

            var maxScrollLeft = getMaxScrollLeft();
            if (list.scrollLeft > maxScrollLeft) {
              list.scrollLeft = maxScrollLeft;
            }
          });

          prevButton.addEventListener(
            'click',
            function (event) {
              event.preventDefault();
              scrollByOneCard(-1);
            }
          );

          nextButton.addEventListener(
            'click',
            function (event) {
              event.preventDefault();
              scrollByOneCard(1);
            }
          );

          list.addEventListener(
            'scroll',
            refreshDisabled
          );

          /*
           * Recalculate after responsive layout changes.
           */
          window.addEventListener(
            'resize',
            refreshDisabled
          );

          refreshDisabled();
        });
    };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      window.clpBindFloatzigCarouselArrows
    );
  } else {
    window.clpBindFloatzigCarouselArrows();
  }

  document.addEventListener(
    'shopify:section:load',
    window.clpBindFloatzigCarouselArrows
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp-hero-xsell"] && !Shopify.designMode) return;
  try {
    
  // .clp-hero-xsell__products' prev/next carousel arrows (rendered by the
  // shared clp-product-carousel snippet) sit absolutely-positioned over
  // the product row here (see the min-width:990px .clp-hero-xsell__products
  // .clp-carousel--feature .clp-carousel__buttons rule in clp.css) - a
  // click meant for the arrow was reaching the product card underneath
  // (fixed separately via z-index in clp.css). Once clicks correctly
  // reached the button, Dawn's own SliderComponent (assets/global.js)
  // still didn't scroll anything - its onButtonClick multiplies a cached
  // this.sliderItemOffset (computed once in initPages(), from the first
  // two slide elements' offsetLeft) into the new scroll position, and
  // that cached value was evidently 0/stale for this instance, silently
  // producing a no-op scrollTo with no error. Rather than continuing to
  // guess why SliderComponent's own cache is wrong for this one instance,
  // this replaces its scroll math for just this section's arrows: measure
  // the real gap between the first two cards fresh, from the live DOM,
  // at the moment of each click, and scroll the actual list by that
  // amount directly - correct regardless of whatever state
  // SliderComponent's cached fields are in. Scoped entirely to
  // .clp-hero-xsell__products, so Featured Tabs, FloatZig X-Sell,
  // Products+Image and every other section reusing the same shared
  // snippet/button markup (and SliderComponent itself) are untouched.
  window.clpBindHeroXsellArrows = window.clpBindHeroXsellArrows || function () {
    document.querySelectorAll('.clp-hero-xsell__products slider-component').forEach(function (carousel) {
      if (carousel.dataset.clpArrowsBound) return;

      var list = carousel.querySelector('.clp-carousel__list');
      var prevButton = carousel.querySelector('button[name="previous"]');
      var nextButton = carousel.querySelector('button[name="next"]');
      if (!list || !prevButton || !nextButton) return;

      carousel.dataset.clpArrowsBound = 'true';

      function items() {
        return Array.from(list.querySelectorAll('.clp-carousel__item'));
      }

      // A single measured step (one card's offsetLeft delta, always a
      // rounded integer) reapplied via relative scrollBy doesn't exactly
      // match card width now that it's a fractional calc() value, and
      // that small error compounds click over click - the exact drift
      // this function used to have. Same fix already proven for this
      // failure mode elsewhere in this codebase (clp-nano-hero.liquid's
      // closestIndex/scrollByOneCard, clp-floatzig-xsell.liquid's
      // equivalent): find the card closest to the current scroll
      // position, move one card index in the requested direction, and
      // scroll straight to THAT card's own freshly-measured offsetLeft
      // via absolute scrollTo - not relative scrollBy. Since every click
      // re-measures the real target position instead of reusing/
      // re-multiplying an earlier rounded step, there's nothing for
      // error to accumulate onto, regardless of how many clicks came
      // before it.
      function closestIndex() {
        var els = items();
        var closest = 0;
        var closestDistance = Infinity;
        els.forEach(function (el, i) {
          var distance = Math.abs(el.offsetLeft - list.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = i;
          }
        });
        return closest;
      }

      function scrollByOneCard(direction) {
        var els = items();
        if (els.length < 2) return;
        var targetIndex = Math.max(0, Math.min(els.length - 1, closestIndex() + direction));
        list.scrollTo({ left: els[targetIndex].offsetLeft, behavior: 'smooth' });
      }

      [prevButton, nextButton].forEach(function (button) {
        button.addEventListener(
          'click',
          function (event) {
            // Capture phase, ahead of SliderComponent's own bubble-phase
            // listener on this same button. stopImmediatePropagation (not
            // just stopPropagation) is required here: SliderComponent's
            // onButtonClick is a second listener on this SAME element, and
            // plain stopPropagation only blocks the event from reaching
            // OTHER elements (e.g. the product card underneath, if the
            // z-index fix is ever bypassed) - it does not stop sibling
            // listeners on this same button from also running. That let
            // SliderComponent's own scrollTo (built from its cached, now
            // stale sliderItemOffset now that card width is fluid) redirect
            // this handler's in-flight smooth scroll to a slightly-off
            // position, leaving a sliver of the next card visible.
            // stopImmediatePropagation suppresses that second listener
            // outright, so this handler's own freshly-measured scroll is
            // the only one that runs. SliderComponent's disabled-state/
            // page-counter updates are unaffected - those come from its
            // separate 'scroll' listener on the list, which still fires
            // normally from this handler's own scrollTo call below.
            event.stopImmediatePropagation();
            scrollByOneCard(button.name === 'next' ? 1 : -1);
          },
          { capture: true }
        );
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.clpBindHeroXsellArrows);
  } else {
    window.clpBindHeroXsellArrows();
  }
  document.addEventListener('shopify:section:load', window.clpBindHeroXsellArrows);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp-nano-hero"] && !Shopify.designMode) return;
  try {
    
  window.clpBindNanoHeroIconArrows = window.clpBindNanoHeroIconArrows || function () {
    document.querySelectorAll('.clp-nano-hero__icons.clp-nano-icons--desktop-slider').forEach(function (carousel) {
      if (carousel.dataset.clpArrowsBound) return;

      var list = carousel.querySelector('.clp-nano-icons__list');
      var oldPrevButton = carousel.querySelector('button[name="previous"]');
      var oldNextButton = carousel.querySelector('button[name="next"]');
      if (!list || !oldPrevButton || !oldNextButton) return;

      carousel.dataset.clpArrowsBound = 'true';

      // Remove Dawn SliderComponent's existing click handlers -
      // cloneNode() copies every attribute/class (so the arrow's own
      // CSS, size, and position are completely unaffected) but never
      // copies attached JS listeners.
      var prevButton = oldPrevButton.cloneNode(true);
      var nextButton = oldNextButton.cloneNode(true);
      oldPrevButton.replaceWith(prevButton);
      oldNextButton.replaceWith(nextButton);

      function items() {
        return Array.from(list.querySelectorAll('.clp-nano-icons__item'));
      }

      // index * step (a single measured gap multiplied by the index)
      // amplifies any tiny sub-pixel measurement error the further a
      // target is into the row, cropping later cards. Reading each
      // item's own actual offsetLeft directly removes that arithmetic
      // entirely - "scroll so this exact element's left edge meets the
      // list's left edge" can't drift regardless of index.
      function closestIndex(scrollLeft) {
        var els = items();
        var closest = 0;
        var closestDistance = Infinity;
        els.forEach(function (el, i) {
          var distance = Math.abs(el.offsetLeft - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = i;
          }
        });
        return closest;
      }

      function maxIndex() {
        var els = items();
        if (!els.length) return 0;
        var max = list.scrollWidth - list.clientWidth;
        var idx = 0;
        els.forEach(function (el, i) {
          if (el.offsetLeft <= max + 1) idx = i;
        });
        return idx;
      }

      function maxScrollLeft() {
        var els = items();
        if (!els.length) return 0;
        return els[maxIndex()].offsetLeft;
      }

      function isDesktopViewport() {
        return window.matchMedia('(min-width: 990px)').matches;
      }

      // Clamps scrollLeft back inside [0, maxScrollLeft()] the instant
      // native scrolling (or anything else) pushes it past either
      // boundary - overflow-x stays auto the whole time (never
      // disabled), this just stops the resting position from ever
      // going past the last/first valid card, regardless of input
      // method. Desktop only - see isDesktopViewport() above.
      function clampScroll() {
        if (!isDesktopViewport()) return;
        var max = maxScrollLeft();
        if (list.scrollLeft > max) {
          list.scrollLeft = max;
        } else if (list.scrollLeft < 0) {
          list.scrollLeft = 0;
        }
      }

      function scrollByOneCard(direction) {
        var els = items();
        if (els.length < 2) return;
        var lastIndex = maxIndex();
        var currentIndex = closestIndex(list.scrollLeft);
        var targetIndex = Math.max(0, Math.min(lastIndex, currentIndex + direction));
        list.scrollTo({ left: els[targetIndex].offsetLeft, behavior: 'smooth' });
      }

      function refreshDisabled() {
        if (!items().length) return;
        var currentIndex = closestIndex(list.scrollLeft);
        prevButton.disabled = currentIndex <= 0;
        nextButton.disabled = currentIndex >= maxIndex();
      }

      function onScroll() {
        clampScroll();
        refreshDisabled();
      }

      prevButton.addEventListener('click', function (event) {
        event.preventDefault();
        scrollByOneCard(-1);
      });
      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        scrollByOneCard(1);
      });

      list.addEventListener('scroll', onScroll);
      window.addEventListener('resize', onScroll);
      onScroll();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.clpBindNanoHeroIconArrows);
  } else {
    window.clpBindNanoHeroIconArrows();
  }
  document.addEventListener('shopify:section:load', window.clpBindNanoHeroIconArrows);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp-nano-product-section"] && !Shopify.designMode) return;
  try {
    
  // Nano desktop carousel:
  // - 3 products visible
  // - 1 product per arrow click

  window.clpBindNanoCarouselArrows =
    window.clpBindNanoCarouselArrows || function () {
      document
        .querySelectorAll(
          '.clp-carousel--nano.clp-carousel--desktop-slider'
        )
        .forEach(function (carousel) {
          if (carousel.dataset.clpArrowsBound) return;

          var list = carousel.querySelector('.clp-carousel__list');
          var oldPrevButton = carousel.querySelector(
            'button[name="previous"]'
          );
          var oldNextButton = carousel.querySelector(
            'button[name="next"]'
          );

          if (!list || !oldPrevButton || !oldNextButton) return;

          carousel.dataset.clpArrowsBound = 'true';

          // Remove Dawn SliderComponent's existing click handlers.
          // cloneNode() preserves markup/classes/attributes but does
          // not copy JavaScript event listeners.
          var prevButton = oldPrevButton.cloneNode(true);
          var nextButton = oldNextButton.cloneNode(true);

          oldPrevButton.replaceWith(prevButton);
          oldNextButton.replaceWith(nextButton);

          function getItems() {
            return Array.from(
              list.querySelectorAll('.clp-carousel__item')
            );
          }

          /*
           * Get the actual rendered scroll position of a card.
           * This avoids percentage/fractional-width calculation errors.
           */
          function getItemScrollLeft(item) {
            if (!item) return list.scrollLeft;

            var listRect = list.getBoundingClientRect();
            var itemRect = item.getBoundingClientRect();

            return list.scrollLeft +
              (itemRect.left - listRect.left);
          }

          /*
           * Find the card currently closest to the left edge.
           */
          function getCurrentIndex() {
            var items = getItems();

            if (!items.length) return 0;

            var listRect = list.getBoundingClientRect();
            var currentScrollLeft = list.scrollLeft;

            var closestIndex = 0;
            var closestDistance = Infinity;

            items.forEach(function (item, index) {
              var itemRect = item.getBoundingClientRect();

              var itemScrollLeft =
                currentScrollLeft +
                (itemRect.left - listRect.left);

              var distance = Math.abs(
                itemScrollLeft - currentScrollLeft
              );

              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            return closestIndex;
          }

          /*
           * Find the final product-card index that can sit at the
           * left edge without creating an invalid partial-card state.
           */
          function getMaxIndex() {
            var items = getItems();

            if (!items.length) return 0;

            var maxScroll =
              list.scrollWidth - list.clientWidth;

            var listRect = list.getBoundingClientRect();

            var maxIndex = 0;

            items.forEach(function (item, index) {
              var itemRect = item.getBoundingClientRect();

              var itemScrollLeft =
                list.scrollLeft +
                (itemRect.left - listRect.left);

              if (itemScrollLeft <= maxScroll + 1) {
                maxIndex = index;
              }
            });

            return maxIndex;
          }

          /*
           * Get the exact final valid scroll position.
           */
          function getFinalScrollPosition() {
            var items = getItems();

            if (!items.length) return 0;

            var lastIndex = getMaxIndex();

            return getItemScrollLeft(items[lastIndex]);
          }

          /*
           * Move to the exact rendered position of a card.
           */
          function scrollToIndex(index) {
            var items = getItems();

            if (!items.length) return;

            var lastIndex = getMaxIndex();

            index = Math.max(
              0,
              Math.min(index, lastIndex)
            );

            var target = getItemScrollLeft(items[index]);

            var maxScroll =
              list.scrollWidth - list.clientWidth;

            target = Math.max(
              0,
              Math.min(target, maxScroll)
            );

            list.scrollTo({
              left: target,
              behavior: 'smooth'
            });
          }

          function scrollByOneCard(direction) {
            var items = getItems();

            if (!items.length) return;

            var currentIndex = getCurrentIndex();
            var lastIndex = getMaxIndex();

            var targetIndex =
              currentIndex + direction;

            targetIndex = Math.max(
              0,
              Math.min(targetIndex, lastIndex)
            );

            if (targetIndex === currentIndex) {
              return;
            }

            scrollToIndex(targetIndex);
          }

          function isDesktopViewport() {
            return window.matchMedia('(min-width: 990px)').matches;
          }

          /*
           * IMPORTANT:
           * If native mouse/trackpad/touch scrolling moves the list
           * beyond the final valid card boundary, immediately clamp
           * it back to that exact card boundary.
           *
           * This is what prevents the carousel from continuing to
           * scroll after the right arrow is disabled. Desktop only -
           * see isDesktopViewport() above.
           */
          function clampToValidPosition() {
            if (!isDesktopViewport()) return;

            var items = getItems();

            if (!items.length) return;

            var lastIndex = getMaxIndex();
            var finalPosition =
              getFinalScrollPosition();

            var currentIndex = getCurrentIndex();

            /*
             * Once the carousel has reached/passed the final valid
             * card position, force it back to the exact boundary.
             */
            if (
              currentIndex >= lastIndex &&
              list.scrollLeft > finalPosition + 1
            ) {
              list.scrollLeft = finalPosition;
            }
          }

          function refreshDisabled() {
            var items = getItems();

            if (!items.length) return;

            var currentIndex = getCurrentIndex();
            var lastIndex = getMaxIndex();

            prevButton.disabled =
              currentIndex <= 0;

            nextButton.disabled =
              currentIndex >= lastIndex;

            /*
             * Keep the list physically aligned with the final
             * product boundary whenever the right arrow is disabled.
             * Desktop only - see isDesktopViewport() above; mobile's
             * own true scroll end doesn't line up with this boundary.
             */
            if (
              isDesktopViewport() &&
              nextButton.disabled &&
              list.scrollLeft >
                getFinalScrollPosition() + 1
            ) {
              list.scrollLeft =
                getFinalScrollPosition();
            }
          }

          prevButton.addEventListener(
            'click',
            function (event) {
              event.preventDefault();

              /*
               * Moving left automatically unlocks the carousel
               * because the right arrow becomes enabled again.
               */
              scrollByOneCard(-1);
            }
          );

          nextButton.addEventListener(
            'click',
            function (event) {
              event.preventDefault();
              scrollByOneCard(1);
            }
          );

          /*
           * Handle native mouse-wheel, trackpad, touch and drag
           * scrolling.
           */
          list.addEventListener(
            'scroll',
            function () {
              clampToValidPosition();
              refreshDisabled();
            }
          );

          /*
           * Recalculate after responsive layout changes.
           */
          window.addEventListener(
            'resize',
            function () {
              refreshDisabled();
            }
          );

          refreshDisabled();
        });
    };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      window.clpBindNanoCarouselArrows
    );
  } else {
    window.clpBindNanoCarouselArrows();
  }

  document.addEventListener(
    'shopify:section:load',
    window.clpBindNanoCarouselArrows
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clp-products-image"] && !Shopify.designMode) return;
  try {
    
  // The scrollable variant of .clp-products-image__grid must show exactly
  // the first 2 complete rows (4 cards - image, badge, title, price, meta,
  // all of it) before anything scrolls. A fixed px height can't do that
  // correctly across different fonts/badge lengths/locales, so this measures
  // the real rendered bottom edge of the 4th card and caps the container
  // there instead - the same measurement approach works identically on the
  // storefront and inside the Theme Editor's iframe.
  window.clpSizeProductsGrid = window.clpSizeProductsGrid || function () {
    document.querySelectorAll('[data-clp-products-grid].clp-products-image__grid--scrollable').forEach(function (grid) {
      if (!window.matchMedia('(min-width: 990px)').matches) {
        grid.style.maxHeight = '';
        return;
      }
      var items = grid.querySelectorAll('.clp-carousel__item');
      if (items.length < 4) {
        grid.style.maxHeight = '';
        return;
      }
      var fourthItemBottom = items[3].getBoundingClientRect().bottom;
      var gridTop = grid.getBoundingClientRect().top;
      grid.style.maxHeight = (fourthItemBottom - gridTop) + 'px';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.clpSizeProductsGrid);
  } else {
    window.clpSizeProductsGrid();
  }
  window.addEventListener('resize', window.clpSizeProductsGrid);
  document.addEventListener('shopify:section:load', window.clpSizeProductsGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Belt-and-suspenders alongside the desktop CSS override above: keep
  // the <details> elements' actual `open` attribute in sync with the
  // viewport, so desktop never depends on whatever open/closed state a
  // shopper left a column in on mobile, regardless of any CSS timing.
  function rbkSyncFooterColumns(isDesktop) {
    document.querySelectorAll('.rbk-footer__col').forEach((col) => {
      if (isDesktop) {
        col.setAttribute('open', '');
      }
    });
  }

  var rbkFooterDesktopQuery = window.matchMedia('(min-width: 750px)');
  rbkSyncFooterColumns(rbkFooterDesktopQuery.matches);
  rbkFooterDesktopQuery.addEventListener('change', (event) => rbkSyncFooterColumns(event.matches));

  // The `placeholder` attribute on .field__input is visually hidden
  // (opacity:0 in base.css) - the floating .field__label is what's
  // actually shown. This only swaps the invisible attribute value
  // itself (autofill heuristics / assistive tech) below 750px; nothing
  // changes on screen.
  var rbkFooterNewsletterInput = document.querySelector('.rbk-footer__signup-form .field__input[data-mobile-placeholder]');
  if (rbkFooterNewsletterInput) {
    var rbkFooterNewsletterDesktopPlaceholder = rbkFooterNewsletterInput.placeholder;
    var rbkFooterNewsletterMobilePlaceholder = rbkFooterNewsletterInput.dataset.mobilePlaceholder;
    function rbkSyncFooterNewsletterPlaceholder(isDesktop) {
      rbkFooterNewsletterInput.placeholder = isDesktop
        ? rbkFooterNewsletterDesktopPlaceholder
        : rbkFooterNewsletterMobilePlaceholder;
    }
    rbkSyncFooterNewsletterPlaceholder(rbkFooterDesktopQuery.matches);
    rbkFooterDesktopQuery.addEventListener('change', (event) => rbkSyncFooterNewsletterPlaceholder(event.matches));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gated-collection-content"]) return;
  try {
    
  class RbkFilterToggle extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('.rbk-filter-toggle__btn');
      this.sidebar = this.querySelector('#main-collection-filters');
      if (!this.btn || !this.sidebar) return;
      this.btn.addEventListener('click', () => {
        const hidden = this.classList.toggle('rbk-filters-hidden');
        this.btn.setAttribute('aria-expanded', String(!hidden));
      });
    }
  }
  if (!customElements.get('rbk-filter-toggle')) {
    customElements.define('rbk-filter-toggle', RbkFilterToggle);
  }

  class RbkColumnToggle extends HTMLElement {
    connectedCallback() {
      // data-col-suffix/data-storage-key default to the original desktop
      // values so the existing desktop <rbk-column-toggle> markup (no
      // data attributes) keeps working unchanged; a mobile instance
      // passes its own suffix/key to target the mobile grid class and
      // persist its column choice independently of the desktop one.
      this.suffix = this.dataset.colSuffix || 'col-desktop';
      this.storageKey = this.dataset.storageKey || 'rbk-plp-cols';
      this.buttons = Array.from(this.querySelectorAll('.rbk-col-toggle__btn'));
      if (this.buttons.length === 0) return;
      this.colValues = this.buttons.map((b) => b.dataset.cols);
      const stored = sessionStorage.getItem(this.storageKey);
      this.setCols(stored || this.dataset.default, false);
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.setCols(btn.dataset.cols));
      });
      this.observer = new MutationObserver(() => {
        this.applyCols(sessionStorage.getItem(this.storageKey) || this.dataset.default);
      });
      const container = document.getElementById('ProductGridContainer');
      if (container) this.observer.observe(container, { childList: true, subtree: true });
    }
    applyCols(cols) {
      // Re-queried fresh every call rather than cached once at connect
      // time: <rbk-column-toggle> sits in the DOM before #product-grid
      // (inside the sidebar, above the grid container), so a custom
      // element that upgrades during initial parsing can connect before
      // the grid element exists yet — caching a null reference then
      // would permanently break both the initial default AND every
      // future click, since the null was never refreshed.
      const grid = document.getElementById('product-grid');
      if (!grid) return;
      this.colValues.forEach((n) => grid.classList.remove(`grid--${n}-${this.suffix}`));
      grid.classList.add(`grid--${cols}-${this.suffix}`);
      this.buttons.forEach((b) => b.classList.toggle('is-active', b.dataset.cols === cols));
    }
    setCols(cols, persist = true) {
      this.applyCols(cols);
      if (persist) sessionStorage.setItem(this.storageKey, cols);
    }
  }
  if (!customElements.get('rbk-column-toggle')) {
    customElements.define('rbk-column-toggle', RbkColumnToggle);
  }

  // Native <select> elements don't reliably shrink-to-fit their
  // currently selected option's text across browsers — some keep the
  // width of whichever option is widest, or the last-measured width,
  // rather than the one actually showing. CSS alone (width:auto,
  // flex:0 0 auto) can't force this consistently, so it's measured
  // directly: a hidden span using the select's own computed font
  // reports the true rendered width of the selected option's text,
  // which is then applied as the select's own inline width. Runs on
  // load, on every 'change' (delegated on document since Dawn's own
  // facet-filters-form AJAX-replaces this <select> outright on
  // filter/sort changes, which would otherwise silently drop a
  // directly-attached listener), and via MutationObserver for the
  // same reason the column toggle above needs one — the element
  // this targets doesn't survive Dawn's own re-render, so a fresh
  // reference has to be re-measured each time the DOM around it
  // changes, not just once at page load.
  function rbkSizeSortSelect() {
    var select = document.getElementById('SortBy');
    if (!select || !select.options.length) return;
    var style = getComputedStyle(select);
    var span = document.createElement('span');
    span.style.position = 'absolute';
    span.style.visibility = 'hidden';
    span.style.whiteSpace = 'nowrap';
    span.style.fontFamily = style.fontFamily;
    span.style.fontSize = style.fontSize;
    span.style.fontWeight = style.fontWeight;
    span.style.letterSpacing = style.letterSpacing;
    span.style.textTransform = style.textTransform;
    span.textContent = select.options[select.selectedIndex].text;
    document.body.appendChild(span);
    select.style.width = span.offsetWidth + 'px';
    span.remove();
  }
  document.addEventListener('DOMContentLoaded', rbkSizeSortSelect);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'SortBy') rbkSizeSortSelect();
  });
  document.querySelectorAll('.rbk-plp-utilitybar').forEach(function (bar) {
    new MutationObserver(rbkSizeSortSelect).observe(bar, { childList: true, subtree: true });
  });

  // Infinite scroll: replaces numbered pagination. Triggers a page-out
  // fetch once the user has scrolled roughly 80% of the way down the
  // full document height (not 80% of the viewport) — matches native
  // "load more before you hit the very bottom" feel without a visible
  // sentinel element. A throttled scroll listener (rAF-gated, so at
  // most one calculation per animation frame) is used instead of
  // IntersectionObserver here specifically because the 80%-of-total-
  // document-height threshold is a moving target as more pages load;
  // expressing that as a fixed IntersectionObserver rootMargin would
  // require recalculating the margin after every append anyway.
  class RbkInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.spinner = this.querySelector('.rbk-infinite-scroll__spinner');
      this.isLoading = false;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      if (!this.dataset.nextUrl) return;
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        this.maybeLoadNext();
      });
    }
    maybeLoadNext() {
      if (this.isLoading || !this.dataset.nextUrl) return;
      var doc = document.documentElement;
      var scrolled = (window.scrollY + window.innerHeight) / doc.scrollHeight;
      if (scrolled >= 0.8) this.loadNext();
    }
    loadNext() {
      if (this.isLoading || !this.dataset.nextUrl) return;
      this.isLoading = true;
      var url = this.dataset.nextUrl;
      if (this.spinner) this.spinner.classList.remove('hidden');
      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          var liveGrid = document.getElementById('product-grid');
          if (newGrid && liveGrid) {
            Array.from(newGrid.children).forEach((item) => {
              liveGrid.appendChild(document.importNode(item, true));
            });
          }
          var newSelf = doc.querySelector('.rbk-infinite-scroll');
          if (newSelf && newSelf.dataset.nextUrl) {
            this.dataset.nextUrl = newSelf.dataset.nextUrl;
          } else {
            delete this.dataset.nextUrl;
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
          }
        })
        .catch((error) => {
          console.error('Infinite scroll: failed to load next page', error);
        })
        .finally(() => {
          this.isLoading = false;
          if (this.spinner) this.spinner.classList.add('hidden');
          // A short page (e.g. the last, partial one) may still leave
          // the scroll position past 80% with room to load more —
          // recheck once appended content has had a layout pass.
          this.maybeLoadNext();
        });
    }
  }
  if (!customElements.get('rbk-infinite-scroll')) {
    customElements.define('rbk-infinite-scroll', RbkInfiniteScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class RbkFilterToggle extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('.rbk-filter-toggle__btn');
      this.sidebar = this.querySelector('#main-collection-filters');
      if (!this.btn || !this.sidebar) return;
      this.btn.addEventListener('click', () => {
        const hidden = this.classList.toggle('rbk-filters-hidden');
        this.btn.setAttribute('aria-expanded', String(!hidden));
      });
    }
  }
  if (!customElements.get('rbk-filter-toggle')) {
    customElements.define('rbk-filter-toggle', RbkFilterToggle);
  }

  class RbkColumnToggle extends HTMLElement {
    connectedCallback() {
      // data-col-suffix/data-storage-key default to the original desktop
      // values so the existing desktop <rbk-column-toggle> markup (no
      // data attributes) keeps working unchanged; a mobile instance
      // passes its own suffix/key to target the mobile grid class and
      // persist its column choice independently of the desktop one.
      this.suffix = this.dataset.colSuffix || 'col-desktop';
      this.storageKey = this.dataset.storageKey || 'rbk-plp-cols';
      this.buttons = Array.from(this.querySelectorAll('.rbk-col-toggle__btn'));
      if (this.buttons.length === 0) return;
      this.colValues = this.buttons.map((b) => b.dataset.cols);
      const stored = sessionStorage.getItem(this.storageKey);
      this.setCols(stored || this.dataset.default, false);
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.setCols(btn.dataset.cols));
      });
      this.observer = new MutationObserver(() => {
        this.applyCols(sessionStorage.getItem(this.storageKey) || this.dataset.default);
      });
      const container = document.getElementById('ProductGridContainer');
      if (container) this.observer.observe(container, { childList: true, subtree: true });
    }
    applyCols(cols) {
      // Re-queried fresh every call rather than cached once at connect
      // time: <rbk-column-toggle> sits in the DOM before #product-grid
      // (inside the sidebar, above the grid container), so a custom
      // element that upgrades during initial parsing can connect before
      // the grid element exists yet — caching a null reference then
      // would permanently break both the initial default AND every
      // future click, since the null was never refreshed.
      const grid = document.getElementById('product-grid');
      if (!grid) return;
      this.colValues.forEach((n) => grid.classList.remove(`grid--${n}-${this.suffix}`));
      grid.classList.add(`grid--${cols}-${this.suffix}`);
      this.buttons.forEach((b) => b.classList.toggle('is-active', b.dataset.cols === cols));
    }
    setCols(cols, persist = true) {
      this.applyCols(cols);
      if (persist) sessionStorage.setItem(this.storageKey, cols);
    }
  }
  if (!customElements.get('rbk-column-toggle')) {
    customElements.define('rbk-column-toggle', RbkColumnToggle);
  }

  // Native <select> elements don't reliably shrink-to-fit their
  // currently selected option's text across browsers — some keep the
  // width of whichever option is widest, or the last-measured width,
  // rather than the one actually showing. CSS alone (width:auto,
  // flex:0 0 auto) can't force this consistently, so it's measured
  // directly: a hidden span using the select's own computed font
  // reports the true rendered width of the selected option's text,
  // which is then applied as the select's own inline width. Runs on
  // load, on every 'change' (delegated on document since Dawn's own
  // facet-filters-form AJAX-replaces this <select> outright on
  // filter/sort changes, which would otherwise silently drop a
  // directly-attached listener), and via MutationObserver for the
  // same reason the column toggle above needs one — the element
  // this targets doesn't survive Dawn's own re-render, so a fresh
  // reference has to be re-measured each time the DOM around it
  // changes, not just once at page load.
  function rbkSizeSortSelect() {
    var select = document.getElementById('SortBy');
    if (!select || !select.options.length) return;
    var style = getComputedStyle(select);
    var span = document.createElement('span');
    span.style.position = 'absolute';
    span.style.visibility = 'hidden';
    span.style.whiteSpace = 'nowrap';
    span.style.fontFamily = style.fontFamily;
    span.style.fontSize = style.fontSize;
    span.style.fontWeight = style.fontWeight;
    span.style.letterSpacing = style.letterSpacing;
    span.style.textTransform = style.textTransform;
    span.textContent = select.options[select.selectedIndex].text;
    document.body.appendChild(span);
    select.style.width = span.offsetWidth + 'px';
    span.remove();
  }
  document.addEventListener('DOMContentLoaded', rbkSizeSortSelect);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'SortBy') rbkSizeSortSelect();
  });
  document.querySelectorAll('.rbk-plp-utilitybar').forEach(function (bar) {
    new MutationObserver(rbkSizeSortSelect).observe(bar, { childList: true, subtree: true });
  });

  // Infinite scroll: replaces numbered pagination. Triggers a page-out
  // fetch once the user has scrolled roughly 80% of the way down the
  // full document height (not 80% of the viewport) — matches native
  // "load more before you hit the very bottom" feel without a visible
  // sentinel element. A throttled scroll listener (rAF-gated, so at
  // most one calculation per animation frame) is used instead of
  // IntersectionObserver here specifically because the 80%-of-total-
  // document-height threshold is a moving target as more pages load;
  // expressing that as a fixed IntersectionObserver rootMargin would
  // require recalculating the margin after every append anyway.
  class RbkInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.spinner = this.querySelector('.rbk-infinite-scroll__spinner');
      this.isLoading = false;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      if (!this.dataset.nextUrl) return;
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        this.maybeLoadNext();
      });
    }
    maybeLoadNext() {
      if (this.isLoading || !this.dataset.nextUrl) return;
      var doc = document.documentElement;
      var scrolled = (window.scrollY + window.innerHeight) / doc.scrollHeight;
      if (scrolled >= 0.8) this.loadNext();
    }
    loadNext() {
      if (this.isLoading || !this.dataset.nextUrl) return;
      this.isLoading = true;
      var url = this.dataset.nextUrl;
      if (this.spinner) this.spinner.classList.remove('hidden');
      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          var liveGrid = document.getElementById('product-grid');
          if (newGrid && liveGrid) {
            Array.from(newGrid.children).forEach((item) => {
              liveGrid.appendChild(document.importNode(item, true));
            });
          }
          var newSelf = doc.querySelector('.rbk-infinite-scroll');
          if (newSelf && newSelf.dataset.nextUrl) {
            this.dataset.nextUrl = newSelf.dataset.nextUrl;
          } else {
            delete this.dataset.nextUrl;
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
          }
        })
        .catch((error) => {
          console.error('Infinite scroll: failed to load next page', error);
        })
        .finally(() => {
          this.isLoading = false;
          if (this.spinner) this.spinner.classList.add('hidden');
          // A short page (e.g. the last, partial one) may still leave
          // the scroll position past 80% with room to load more —
          // recheck once appended content has had a layout pass.
          this.maybeLoadNext();
        });
    }
  }
  if (!customElements.get('rbk-infinite-scroll')) {
    customElements.define('rbk-infinite-scroll', RbkInfiniteScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class RbkFilterToggle extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('.rbk-filter-toggle__btn');
      this.sidebar = this.querySelector('#main-collection-filters');
      if (!this.btn || !this.sidebar) return;
      this.btn.addEventListener('click', () => {
        const hidden = this.classList.toggle('rbk-filters-hidden');
        this.btn.setAttribute('aria-expanded', String(!hidden));
      });
    }
  }
  if (!customElements.get('rbk-filter-toggle')) {
    customElements.define('rbk-filter-toggle', RbkFilterToggle);
  }

  class RbkColumnToggle extends HTMLElement {
    connectedCallback() {
      this.suffix = this.dataset.colSuffix || 'col-desktop';
      this.storageKey = this.dataset.storageKey || 'rbk-plp-cols';
      this.buttons = Array.from(this.querySelectorAll('.rbk-col-toggle__btn'));
      if (this.buttons.length === 0) return;
      this.colValues = this.buttons.map((b) => b.dataset.cols);
      const stored = sessionStorage.getItem(this.storageKey);
      this.setCols(stored || this.dataset.default, false);
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.setCols(btn.dataset.cols));
      });
      this.observer = new MutationObserver(() => {
        this.applyCols(sessionStorage.getItem(this.storageKey) || this.dataset.default);
      });
      const container = document.getElementById('ProductGridContainer');
      if (container) this.observer.observe(container, { childList: true, subtree: true });
    }
    applyCols(cols) {
      const grid = document.getElementById('product-grid');
      if (!grid) return;
      this.colValues.forEach((n) => grid.classList.remove(`grid--${n}-${this.suffix}`));
      grid.classList.add(`grid--${cols}-${this.suffix}`);
      this.buttons.forEach((b) => b.classList.toggle('is-active', b.dataset.cols === cols));
    }
    setCols(cols, persist = true) {
      this.applyCols(cols);
      if (persist) sessionStorage.setItem(this.storageKey, cols);
    }
  }
  if (!customElements.get('rbk-column-toggle')) {
    customElements.define('rbk-column-toggle', RbkColumnToggle);
  }

  function rbkSizeSortSelect() {
    var select = document.getElementById('SortBy');
    if (!select || !select.options.length) return;
    var style = getComputedStyle(select);
    var span = document.createElement('span');
    span.style.position = 'absolute';
    span.style.visibility = 'hidden';
    span.style.whiteSpace = 'nowrap';
    span.style.fontFamily = style.fontFamily;
    span.style.fontSize = style.fontSize;
    span.style.fontWeight = style.fontWeight;
    span.style.letterSpacing = style.letterSpacing;
    span.style.textTransform = style.textTransform;
    span.textContent = select.options[select.selectedIndex].text;
    document.body.appendChild(span);
    select.style.width = span.offsetWidth + 'px';
    span.remove();
  }
  document.addEventListener('DOMContentLoaded', rbkSizeSortSelect);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'SortBy') rbkSizeSortSelect();
  });
  document.querySelectorAll('.rbk-plp-utilitybar').forEach(function (bar) {
    new MutationObserver(rbkSizeSortSelect).observe(bar, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-banner"] && !Shopify.designMode) return;
  try {
    
  window.secondaryBannerBindAutoplay = window.secondaryBannerBindAutoplay || function () {
    document.querySelectorAll('.secondary-banner slider-component').forEach(function (carousel) {
      if (carousel.dataset.autoplayBound) return;

      var list = carousel.querySelector('.secondary-banner__list');
      var slides = list ? Array.from(list.querySelectorAll('.secondary-banner__slide')) : [];
      if (slides.length < 2) return;

      carousel.dataset.autoplayBound = 'true';

      var autoplaySpeed = 5000;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;

      function closestIndex() {
        var closest = 0;
        var closestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - list.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = index;
          }
        });
        return closest;
      }

      function advance() {
        var nextIndex = closestIndex() + 1;
        if (nextIndex >= slides.length) nextIndex = 0;
        list.scrollTo({ left: slides[nextIndex].offsetLeft, behavior: 'smooth' });
      }

      function play() {
        if (reducedMotion) return;
        stop();
        timer = setInterval(advance, autoplaySpeed);
      }

      function stop() {
        clearInterval(timer);
        timer = null;
      }

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', play);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', play);

      play();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.secondaryBannerBindAutoplay);
  } else {
    window.secondaryBannerBindAutoplay();
  }
  document.addEventListener('shopify:section:load', window.secondaryBannerBindAutoplay);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trending-carousel"] && !Shopify.designMode) return;
  try {
    
  class TrendingCarousel extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.rbk-trending');
      this.tabs = Array.from(this.querySelectorAll('.rbk-trending__tab'));
      this.panels = Array.from(this.section.querySelectorAll('.rbk-trending__panel'));
      this.cta = this.section.querySelector('.rbk-trending__viewall a');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab.dataset.tabIndex));
      });

      this.prevArrow = this.querySelector('.rbk-trending__arrow[data-direction="prev"]');
      this.nextArrow = this.querySelector('.rbk-trending__arrow[data-direction="next"]');

      this.querySelectorAll('.rbk-trending__arrow').forEach((arrow) => {
        arrow.addEventListener('click', () => this.scrollActive(arrow.dataset.direction));
      });

      this.panels.forEach((panel) => {
        const track = panel.querySelector('.rbk-trending__track');
        if (track) track.addEventListener('scroll', () => this.updateArrowState(), { passive: true });
      });

      window.addEventListener('resize', () => this.updateArrowState());
      this.updateArrowState();
    }

    activateTab(index) {
      let activeTab = null;
      this.tabs.forEach((tab) => {
        const active = tab.dataset.tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active);
        if (active) activeTab = tab;
      });
      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.tabPanel === index);
      });
      if (this.cta && activeTab) {
        if (activeTab.dataset.ctaLabel) this.cta.textContent = activeTab.dataset.ctaLabel;
        this.cta.setAttribute('href', activeTab.dataset.ctaLink || '#');
      }
      this.updateArrowState();
    }

    scrollActive(direction) {
      const track = this.activeTrack();
      if (!track) return;
      const item = track.querySelector('.rbk-trending__item');
      const amount = item ? item.getBoundingClientRect().width + 4 : track.clientWidth * 0.8;
      const delta = direction === 'next' ? amount : -amount;
      // In RTL, content starts at scrollLeft 0 (rightmost) and advancing toward
      // later items drives scrollLeft negative, the opposite of LTR — flip the
      // sign so "next" still moves forward instead of back toward the start.
      const isRtl = this.closest('html').dir === 'rtl';
      track.scrollBy({ left: isRtl ? -delta : delta, behavior: 'smooth' });
    }

    activeTrack() {
      const panel = this.section.querySelector('.rbk-trending__panel.is-active');
      return panel ? panel.querySelector('.rbk-trending__track') : null;
    }

    updateArrowState() {
      if (!this.prevArrow && !this.nextArrow) return;
      const track = this.activeTrack();
      if (!track) return;
      const isRtl = this.closest('html').dir === 'rtl';
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (isRtl) {
        if (this.prevArrow) this.prevArrow.disabled = track.scrollLeft >= -1;
        if (this.nextArrow) this.nextArrow.disabled = track.scrollLeft <= -(maxScroll - 1);
      } else {
        if (this.prevArrow) this.prevArrow.disabled = track.scrollLeft <= 1;
        if (this.nextArrow) this.nextArrow.disabled = track.scrollLeft >= maxScroll - 1;
      }
    }
  }

  customElements.define('trending-carousel', TrendingCarousel);

  } catch(e) { console.error(e); }
})();
})();
